import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse, ApiListResponse } from '../lib/response';

import { Demo, DemoType, DemoStatus } from '../models/demo';

export class DemoService extends BaseService<Demo> {
  override model = Demo;
  override modelName = 'demo';
  override modelLabel = 'Demo';

  async types(): Promise<ApiListResponse<DemoType>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/types`,
    });

    return await this.requestList(request, DemoType);
  }

  async create({
    firstName,
    lastName,
    email,
    businessType,
    skipSignUp = 0,
  }: {
    firstName: string;
    lastName: string;
    email: string;
    businessType: string;
    skipSignUp?: number;
  }): Promise<ApiResponse<Demo>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/create`,
      data: { firstName, lastName, email, businessType, skipSignUp },
    });

    return await this.requestItem(request, Demo);
  }

  async status(
    demo: Demo,
  ): Promise<ApiResponse<DemoStatus>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/${demo.objectID()}/check`,
    });

    return await this.requestItem(request, DemoStatus);
  }
}
